export default {
  // Search
  search: {
    title: 'Search',
    resultsFor: 'Results for',
    noResults: 'No results found',
    startSearching: 'Start searching',
  },

  // Home
  home: {
    welcomeBack: 'Welcome Back',
    discoverTravel: 'Discover Travel',
    discoverPlans: 'Discover amazing travel plans',
    whereToGo: 'Where do you want to go?',
    viewMore: 'View More',
    recommendedCards: 'Recommended Cards',
    latestPosts: 'Latest Posts',
    loginPrompt: 'Log in to create and manage your itinerary',
    loginButton: 'Login / Register',
  },

  // Card List
  cardList: {
    title: 'Browse Cards',
    searchPlaceholder: 'Search cards...',
    types: {
      poi: 'Attractions',
      restaurant: 'Restaurants',
      lodging: 'Lodging',
      activity: 'Activities',
      shopping: 'Shopping',
    },
    filters: {
      tags: 'Tags',
      category: 'Category',
      subcategory: 'Subcategory',
      location: 'Location',
      clear: 'Clear',
    },
    status: {
      loading: 'Loading...',
      switchingPages: 'Switching pages...',
      noMore: 'No more cards',
      emptyTitle: 'No cards found',
      emptyText: 'Try adjusting search criteria or filters',
    },
    modal: {
      title: 'Card Details',
      close: 'Close',
      addToItinerary: 'Add to Itinerary',
    }
  },

  // Module Header
  header: {
    title: 'Travel',
    subtitle: 'Smart Itinerary Recommendations, AI Receipt Recognition',
  },

  common: {
    close: 'Close',
  },

  // Travel Card
  travelCard: {
    status: {
      active: 'Active',
      planning: 'Planning',
      completed: 'Completed',
      cancelled: 'Cancelled',
    },
    actions: {
      viewDetails: 'View Details',
      joinTravel: 'Join Travel',
      editTravel: 'Edit Travel',
      enterChat: 'Chat',
    },
    info: {
      members: 'Cubers',
      budget: 'Budget',
      duration: 'Duration',
      days: 'days',
      perPerson: '/ person',
      noLocation: 'Location not set',
      noBudget: 'Budget not set',
      noMembers: 'No members yet',
      memberCount: '{{count}} Cuber',
      memberCount_plural: '{{count}} Cubers',
      actualCost: 'Actual Cost',
      public: 'Public',
      friendsOnly: 'Friends Only',
      private: 'Private',
    },
    dates: {
      to: 'to',
      startDate: 'Start Date',
      endDate: 'End Date',
    },
  },

  // Travel List
  travelList: {
    loading: {
      title: 'Loading travel list...',
      subtitle: 'Please wait',
    },
    empty: {
      title: 'No projects yet',
      subtitle: 'Click the create button to start a project, or click discover to join others',
    },
    discover: {
      title: 'Discover',
    },
    messages: {
      error: 'Error',
      fetchListFailed: 'Failed to fetch project list',
      unknownError: 'Unknown error',
      likeFailed: 'Like operation failed',
      likeSuccess: 'Liked',
      unlikeSuccess: 'Unliked',
    },
  },

  // Create Travel
  createTravel: {
    // Page Header
    header: {
      title: 'Create Travel',
      subtitle: 'Fill in project information',
    },
    title: 'Create Travel',
    // Basic Information
    projectName: 'Project Name',
    projectNamePlaceholder: 'Give your travel a name',
    dateRange: 'Travel Dates',
    startDate: 'Departure Date',
    endDate: 'Return Date',
    // Destination
    destination: 'Destination',
    selectCountry: 'Select Country',
    selectCity: 'Select City',
    customCity: 'Or enter custom city',
    customCityPlaceholder: 'Enter city name (e.g., Paris, Tokyo, New York)',
    destinationLabel: 'Destination: ',
    // Travel Preferences
    travelPreferences: 'Your Travel Preferences',
    preferencesSubtitle: 'Select what interests you to help AI customize your itinerary',
    multiSelect: '(Multiple selection)',
    // Preference Options
    preferences: {
      culture: 'Culture',
      food: 'Food',
      scenery: 'Scenery',
      history: 'History',
      deepTour: 'Deep Tour',
      checkin: 'Check-in',
    },
    // Project Description
    projectDescription: 'Project Description',
    projectDescriptionPlaceholder: 'Introduce the features and highlights of this trip...',
  editItinerary: 'Edit Itinerary',
    descriptionPlaceholder: 'Introduce the features and highlights of this trip...',
    aiGenerate: 'AI Smart Generate Description',
  aiGenerating: 'Generating...',
  aiGenerateItinerary: 'Generate itinerary with AI',
  regenerate: 'Regenerate',
  itineraryPreview: 'Itinerary Preview',
    itineraryEmptySimple: 'Tap to edit and start your itinerary',
    // Payment Mode
    paymentMode: 'Payment Mode',
    prepayAverage: 'Prepay Average',
    prepayAverageDesc: 'Collect fixed amount in advance, split evenly',
    prepayShare: 'Prepay Share',
    prepayShareDesc: 'Collect fixed amount in advance, split by share',
    actualAverage: 'Actual Cost (Average)',
    actualAverageDesc: 'Split evenly after actual expenses',
    actualShare: 'Actual Cost (Share)',
    actualShareDesc: 'Split by share after actual expenses',
    // Settlement Currency
    settlementCurrency: 'Settlement Currency',
    selectCurrency: 'Select Currency',
    // Currency Names
    currencies: {
      CNY: 'Chinese Yuan',
      USD: 'US Dollar',
      EUR: 'Euro',
      JPY: 'Japanese Yen',
      GBP: 'British Pound',
      AUD: 'Australian Dollar',
      CAD: 'Canadian Dollar',
      CHF: 'Swiss Franc',
      HKD: 'Hong Kong Dollar',
      SGD: 'Singapore Dollar',
      KRW: 'Korean Won',
      TWD: 'Taiwan Dollar',
      THB: 'Thai Baht',
      MYR: 'Malaysian Ringgit',
    },
    // Budget Per Person
    budgetPerPerson: 'Budget Per Person',
    budgetPlaceholder: '0',
    budgetUnit: '/ person',
    budgetHint: 'Estimated cost per person for budget planning and member reference',
    // Project Visibility
    projectVisibility: 'Project Visibility',
    visibilitySubtitle: 'Choose who can see and join your travel project',
    publicProject: 'Public Project',
    publicProjectDesc: 'Everyone can see and apply to join',
    friendsVisible: 'Friends Visible',
    friendsVisibleDesc: 'Friends can see and apply to join',
    privateProject: 'Private Project',
    privateProjectDesc: 'Invite friends only',
    // Background Image
    backgroundImage: 'Background Image',
    selectBackground: 'Select Background',
  backgroundPlaceholder: 'Click to select background image',
  // Alternate key used in some components
  selectBackgroundPlaceholder: 'Click to select background image',
    backgroundImages: {
      beach: 'Beach Vacation',
      churches: 'Church Architecture',
      airplane: 'Flight Journey',
      cruise: 'Cruise Travel',
      fuji: 'Mount Fuji',
      germany: 'German Scenery',
      holland: 'Dutch Windmill',
      hongkong: 'Hong Kong Night',
      korea: 'Korean Landscape',
      london: 'London Impression',
      maldives: 'Maldives',
      mountain: 'Mountain Snow',
      paris: 'Paris Romance',
      sakura: 'Cherry Blossoms',
      sea: 'Azure Ocean',
      shanghai: 'Shanghai Scenery',
      singapore: 'Singapore Impression',
      snow: 'Snowfall',
      sunrise: 'Sunrise East',
      sunsets: 'Sunset West',
      swiss: 'Swiss Landscape',
      thailand: 'Thailand Style',
      vietnam: 'Vietnam Impression',
      waterfalls: 'Flying Waterfalls',
    },
    // Buttons
    createProject: 'Create Travel Project',
    next: 'Create Travel',
    // Alert Messages
    alerts: {
      hint: 'Hint',
      success: 'Success',
      error: 'Error',
      enterProjectName: 'Please enter project name',
      selectDestination: 'Please select destination',
      selectDestinationCity: 'Please select destination city',
      enterProjectDescription: 'Please enter project description',
      invalidDateRange: 'End date cannot be earlier than start date',
      generatedSuccess: 'AI description generated successfully!',
      generateFailed: 'AI generation failed',
      aiGenerationFailed: 'AI generation failed',
      errorDetails: 'Error details',
      createSuccess: 'Travel project created successfully!',
      createSuccessMessage: 'Your travel project has been created successfully. Invite friends to join!',
      createFailed: 'Creation failed',
      createFailedMessage: 'Please check your network connection and try again',
      createFailedDetail: 'If the problem persists, please contact customer service.',
      userNotLoggedIn: 'User not logged in, please log in first',
      unknownError: 'Unknown error',
      travelCreateFailed: 'Travel creation failed',
      viewProject: 'View Project',
      // AI related alerts
      aiDisabledMessage: 'AI smart recommendation feature is disabled\nAI itinerary generation cancelled\nYou can re-enable it in settings',
      goToSettings: 'Go to Settings',
    },
    // Warning messages
    warnings: {
      editBeforeCreate: 'Recommend completing creation first before editing itinerary',
      continueEdit: 'Continue Edit',
    },
    // AI Prompt related
    aiPrompt: {
      role: 'You are a professional travel planner. Please generate a detailed, attractive and practical itinerary introduction for the following travel project.',
      // Basic information section
      basicInfo: 'Project Basic Information',
      projectNameLabel: 'Project Name',
      destinationLabel: 'Destination',
      travelTimeLabel: 'Travel Time',
      participantsLabel: 'Participants',
      preferencesLabel: 'Travel Preferences',
      budgetLabel: 'Budget per Person',
      noPreferences: 'No specific preferences',
      budgetTbd: 'Budget to be determined',
      paymentModeLabel: 'Payment Mode',
      daysCount: '({days} days total)',
      // Payment mode mapping
      paymentModes: {
        prepay_average: 'Prepaid Average Mode',
        prepay_share: 'Prepaid Share Mode',
        actual_average: 'Actual Cost Average Mode',
        actual_share: 'Actual Cost Share Mode',
      },
      // Requirements section
      requirements: 'Generation Requirements',
      generateContent: 'Please generate an itinerary introduction that includes the following content:',
      contentItems: {
        highlights: '**Project Highlights**: Based on destination features and user preferences, highlight the unique aspects of this trip',
        itinerary: '**Detailed Itinerary**: Plan specific attractions, activities and experiences by day',
        food: '**Food Recommendations**: Local specialties and restaurant recommendations',
        accommodation: '**Accommodation Suggestions**: Suitable accommodation types and areas for teams',
        transportation: '**Transportation Guide**: How to reach the destination and local transportation options',
        budget: '**Budget Reference**: Approximate budget ranges for various expenses',
        tips: '**Practical Tips**: Including weather, visa, essential items and other practical information',
        teamActivities: '**Team Activities**: Special activities suitable for {min}-{max} person teams',
      },
      // Style requirements section
      styleRequirements: 'Style Requirements',
      styleItems: {
        0: 'Vivid and interesting language, full of appeal',
        1: 'Detailed and specific content with practicality',
        2: 'Highlight teamwork and social attributes',
        3: 'Reflect the economic benefits and fun of group travel',
        4: 'Use appropriate emojis to add interest',
        5: 'Keep total word count within 400-500 words',
      },
      generateStart: 'Please start generating:',
    },
  },

  // Travel Detail Page
  travelDetail: {
    actions: {
      editItinerary: 'Edit Itinerary',
      approve: 'Approve',
      reject: 'Reject',
      settlement: 'Payment Settings',
    },
    loading: {
      title: 'Loading travel details...',
      subtitle: 'Please wait',
    },
    error: {
      title: 'Loading failed',
      subtitle: 'Travel project not found',
      retryButton: 'Reload',
    },
    // Page Content
    content: {
      projectDescription: 'Project Description',
  itineraryOverview: 'Itinerary',
      todoList: 'Todo List',
      members: 'Travel Members',
      add: 'Add',
      expand: 'Expand',
      collapse: 'Collapse',
      expandWithCount: 'Expand ({{count}} items)',
      unknownUser: 'Unknown User',
      creator: 'Creator',
      member: 'Member',
  pending: 'Pending',
  pendingAdd: 'Pending - New',
  pendingEdit: 'Pending - Edit',
      completed: 'Completed',
      inviteFriends: 'Invite Friends',
      recommendFriends: 'Recommend Friends',
      noTodos: 'No todos yet',
      noTodosSubtext: 'Click the add button in the top right to create todos',
    },
    // Modal
    modal: {
      paymentSettings: 'Payment Settings',
      paymentMode: 'Payment Mode',
      memberShareSettings: 'Member Share Settings',
      memberShareDescription: 'Set share ratio for each member. For example: Adult 1.0, Child 0.5, Couple 2.0',
      totalShares: 'Total Shares',
      averageMode: 'Average Mode',
      shareMode: 'Share Mode',
      prepaidMode: 'Prepaid Mode (Travel agency mode, no refund)',
      actualExpenseMode: 'Actual Expense Mode (Split by actual costs)',
      currentProjectUses: 'Current project uses',
    },
    // Messages
    messages: {
      success: 'Success',
      error: 'Error',
      loadFailed: 'Failed to load travel details',
      unknownError: 'Unknown error',
      userNotLoggedIn: 'User not logged in',
      paymentSettingsSaved: 'Payment settings saved',
      saveShareSettingsFailed: 'Failed to save share settings',
      addTodoFailed: 'Failed to add todo',
      batchAddTodosFailed: 'Failed to batch add todos',
      todosAdded: 'Added {{count}} todos',
      operationFailed: 'Operation failed',
      likeFailed: 'Like operation failed',
      insufficientPermission: 'Insufficient Permission',
      needJoinFirst: 'You need to join the project first to recommend friends',
      onlyCreatorCanInvite: 'Only project creator can invite friends to private projects',
      savePaymentModeFailed: 'Failed to save payment mode',
    },
  },

  // Expense Settings Modal
  expenseSettingsModal: {
    // Header
    title: 'Expense Sharing Settings',
    cancel: 'Cancel',
    save: 'Save',
    // Permission Notice
    permissionNotice: 'Only travel creators can modify expense settings',
    // Expense Mode
    expenseModeSection: {
      title: '📊 Sharing Mode',
      subtitle: 'Choose the expense management method suitable for your travel activity',
      // Prepaid Mode
      prepaidMode: {
        title: 'Prepaid Mode',
        subtitle: 'Members pay in advance, unified expense management',
        description: 'Suitable for travel activities with clear budgets, such as tourism, gatherings, etc. Requires setting a total budget.',
        features: [
          'Set total budget amount',
          'Members prepay by share ratio',
          'Real-time balance tracking',
          'Refund or top-up settlement',
        ],
      },
      // Actual Expense Mode
      actualExpenseMode: {
        title: 'Actual Expense Mode',
        subtitle: 'Members pay their own expenses, split by actual costs later',
        description: 'Suitable for travel activities with uncertain costs, such as project collaborations, etc. No preset budget required.',
        features: [
          'Upload receipts',
          'Expense approval process',
          'Flexible category management',
          'Actual expense splitting',
        ],
      },
    },
    // Share Settings
    shareSection: {
      title: '⚖️ Share Ratio',
      subtitle: 'Choose the specific expense sharing method',
      toggleTitle: 'Enable Share-based Splitting',
      // Different mode descriptions
      descriptions: {
        prepaidWithShares: 'Refund or top-up based on actual consumption after prepayment, considering individual differences',
        prepaidWithoutShares: 'Like travel group mode, creator arranges everything, split evenly',
        actualExpenseWithShares: 'Split actual expenses by member share ratios',
        actualExpenseWithoutShares: 'Split all expenses evenly, not considering individual differences',
      },
      // Share splitting examples
      shareExamples: {
        title: '💡 Share Splitting Instructions',
        prepaidMode: 'Prepaid Mode + Share Splitting:\n• Members prepay different amounts by share ratio\n• Recalculate based on actual consumption after activity\n• Refund or top-up, reflecting individual differences\n• Suitable for: Family travel, friend gatherings',
        actualExpenseMode: 'Actual Expense + Share Splitting:\n• Members pay individually, upload receipts\n• Split total expenses by share ratio\n• Final unified settlement of differences\n• Suitable for: Project collaboration, AA gatherings',
      },
      // Average splitting examples
      averageExamples: {
        title: '📋 Average Splitting Instructions',
        prepaidMode: 'Prepaid Mode + Average Splitting:\n• Everyone prepays the same amount\n• Creator arranges all activities uniformly\n• Remaining funds refunded evenly or continued use\n• Suitable for: Company team building, travel groups',
        actualExpenseMode: 'Actual Expense + Average Splitting:\n• Members pay individually, upload receipts\n• Total expenses split evenly among all\n• Final unified settlement of differences\n• Suitable for: Temporary activities, colleague gatherings',
      },
    },
    // Current Settings Preview
    currentSettings: {
      title: '📋 Current Settings',
      expenseMode: 'Sharing Mode',
      shareMode: 'Share Splitting',
      currency: 'Currency',
      prepaidMode: 'Prepaid Mode',
      actualExpenseMode: 'Actual Expense Mode',
      enabled: 'Enabled',
      averageMode: 'Average Splitting',
    },
  },

  // Expense Statistics
  statistics: {
    title: 'Travel Statistics',
    loading: 'Calculating statistics...',
    // Summary Statistics
    summary: {
      totalSpent: 'Total Spent',
      approvedAmount: 'Approved Amount',
      averageShare: 'Average Share',
      averageSpent: 'Average Spent',
      budgetUsage: 'Budget Usage',
      expenseRecords: 'Expense Records',
      approvedReceipts: 'Approved Receipts',
      budgetProgress: 'Budget Usage',
      pending: 'Pending',
      rejected: 'Rejected',
      receipts: ' receipts',
      groupMode: 'Group Mode: Prepaid, evenly split, simplified management',
    },
    // Category Statistics
    categories: {
      title: 'Expense Categories',
      transport: 'Transport',
      accommodation: 'Accommodation',
      food: 'Food',
      activities: 'Activities',
      shopping: 'Shopping',
      documents: 'Documents',
      other: 'Other',
    },
    // Member Statistics
    members: {
      shareDetails: 'Member Share Details',
      spentStats: 'Member Spending Stats',
      participation: 'Member Participation',
      shareAmount: 'Share Amount',
      difference: 'Difference',
      shouldReceive: 'Should Receive',
      shouldPay: 'Should Pay',
      remainingBalance: 'Remaining Balance',
      needPayment: 'Need Payment',
      balanced: 'Balanced',
      unknownUser: 'Unknown User',
      totalSpent: 'Total Spent',
      averagePerPerson: 'Average per Person',
      spent: 'spent',
      transactions: ' transactions',
    },
  },

  // Add Todo Modal
  addTodoModal: {
    // Header
    title: 'Add Todo Item',
    // Custom Add
    customAdd: {
      title: 'Custom Add',
      titleLabel: 'Title',
      titlePlaceholder: 'Enter todo item title',
      descriptionLabel: 'Description',
      descriptionPlaceholder: 'Enter detailed description (optional)',
      priorityLabel: 'Priority',
    },
    // Priority
    priority: {
      high: 'High',
      medium: 'Medium',
      low: 'Low',
    },
  },

  // Invite Friends Screen
  inviteFriends: {
    header: {
      title: 'Invite Friends',
      subtitle: 'Invite friends to join "{{groupName}}"',
    },
    search: {
      placeholder: 'Search friends...',
    },
    sections: {
      available: 'Available Friends',
      members: 'Already Members',
      pending: 'Pending Invitations',
    },
    status: {
      joined: 'Already joined the project',
      invitationSent: 'Invitation sent, waiting for reply',
    },
    actions: {
      sendInvitations: 'Send Invitations',
      sending: 'Sending...',
      continueInviting: 'Continue Inviting',
      goBack: 'Go Back',
    },
    loading: {
      text: 'Loading friends list...',
    },
    empty: {
      noFriends: {
        title: 'No Friends',
        subtitle: 'Add some friends first',
      },
      noResults: {
        title: 'No Search Results',
        subtitle: 'Try other keywords',
      },
    },
    selection: {
      count: 'Selected {{count}} friends',
      sendCount: 'Send Invitations ({{count}})',
    },
    alerts: {
      selectFriends: 'Please select friends to invite',
      userInfoFailed: 'Failed to get user information',
      invitationSuccess: 'Invitations sent successfully',
      invitationSuccessMessage: 'Invitations sent to {{names}}',
      loadFriendsFailed: 'Failed to load friends list',
      sendInvitationsFailed: 'Failed to send invitations',
      error: 'Error',
      hint: 'Hint',
      unknownError: 'Unknown error',
      unknownUser: 'Unknown user',
    },
  },

  // Destinations data
  destinations: {
    countries: {
      // Asia
      CN: 'China',
      HK: 'Hong Kong',
      MO: 'Macau',
      TW: 'Taiwan',
      JP: 'Japan',
      KR: 'South Korea',
      TH: 'Thailand',
      SG: 'Singapore',
      MY: 'Malaysia',
      VN: 'Vietnam',
      ID: 'Indonesia',
      IN: 'India',
      AE: 'United Arab Emirates',
      // Europe
      GB: 'United Kingdom',
      FR: 'France',
      DE: 'Germany',
      IT: 'Italy',
      ES: 'Spain',
      NL: 'Netherlands',
      CH: 'Switzerland',
      // North America
      US: 'United States',
      CA: 'Canada',
      // Oceania
      AU: 'Australia',
      NZ: 'New Zealand',
    },
    cities: {
      // City-level destinations
      HongKong: 'Hong Kong',
      Macau: 'Macau',
      Singapore: 'Singapore',
      // China cities
      Beijing: 'Beijing',
      Shanghai: 'Shanghai',
      Guangzhou: 'Guangzhou',
      Shenzhen: 'Shenzhen',
      Hangzhou: 'Hangzhou',
      Chengdu: 'Chengdu',
      Xian: 'Xi\'an',
      Chongqing: 'Chongqing',
      Wuhan: 'Wuhan',
      Nanjing: 'Nanjing',
      // Taiwan cities
      Taipei: 'Taipei',
      Kaohsiung: 'Kaohsiung',
      Taichung: 'Taichung',
      Tainan: 'Tainan',
      // Japan cities
      Tokyo: 'Tokyo',
      Osaka: 'Osaka',
      Kyoto: 'Kyoto',
      'JP-Kyoto': 'Kyoto',
      Nagoya: 'Nagoya',
      Fukuoka: 'Fukuoka',
      Sapporo: 'Sapporo',
      // South Korea cities
      Seoul: 'Seoul',
      Busan: 'Busan',
      Daegu: 'Daegu',
      Incheon: 'Incheon',
      // Thailand cities
      Bangkok: 'Bangkok',
      ChiangMai: 'Chiang Mai',
      Phuket: 'Phuket',
      Pattaya: 'Pattaya',
      // Malaysia cities
      KualaLumpur: 'Kuala Lumpur',
      Penang: 'Penang',
      Malacca: 'Malacca',
      JohorBahru: 'Johor Bahru',
      // Vietnam cities
      HoChiMinhCity: 'Ho Chi Minh City',
      Hanoi: 'Hanoi',
      DaNang: 'Da Nang',
      NhaTrang: 'Nha Trang',
      // Indonesia cities
      Jakarta: 'Jakarta',
      Bali: 'Bali',
      Yogyakarta: 'Yogyakarta',
      Surabaya: 'Surabaya',
      // India cities
      NewDelhi: 'New Delhi',
      Mumbai: 'Mumbai',
      Bangalore: 'Bangalore',
      Kolkata: 'Kolkata',
      // UAE cities
      Dubai: 'Dubai',
      AbuDhabi: 'Abu Dhabi',
      // UK cities
      London: 'London',
      Edinburgh: 'Edinburgh',
      Manchester: 'Manchester',
      Liverpool: 'Liverpool',
      // France cities
      Paris: 'Paris',
      Lyon: 'Lyon',
      Marseille: 'Marseille',
      Nice: 'Nice',
      // Germany cities
      Berlin: 'Berlin',
      Munich: 'Munich',
      Hamburg: 'Hamburg',
      Frankfurt: 'Frankfurt',
      // Italy cities
      Rome: 'Rome',
      Milan: 'Milan',
      Venice: 'Venice',
      Florence: 'Florence',
      // Spain cities
      Madrid: 'Madrid',
      Barcelona: 'Barcelona',
      Valencia: 'Valencia',
      Seville: 'Seville',
      // Netherlands cities
      Amsterdam: 'Amsterdam',
      Rotterdam: 'Rotterdam',
      TheHague: 'The Hague',
      // Switzerland cities
      Zurich: 'Zurich',
      Geneva: 'Geneva',
      Basel: 'Basel',
      // USA cities
      NewYork: 'New York',
      LosAngeles: 'Los Angeles',
      Chicago: 'Chicago',
      SanFrancisco: 'San Francisco',
      LasVegas: 'Las Vegas',
      Miami: 'Miami',
      // Canada cities
      Toronto: 'Toronto',
      Vancouver: 'Vancouver',
      Montreal: 'Montreal',
      Ottawa: 'Ottawa',
      // Australia cities
      Sydney: 'Sydney',
      Melbourne: 'Melbourne',
      Brisbane: 'Brisbane',
      Perth: 'Perth',
      // New Zealand cities
      Auckland: 'Auckland',
      Wellington: 'Wellington',
      Christchurch: 'Christchurch',
    },
  },

  // Travel Chat
  travelChat: {
    header: {
      title: '{{groupName}} Chat Room',
      subtitle: 'Travel Group Chat',
    },
    loading: {
      text: 'Loading chat history...',
    },
    empty: {
      title: 'No chat history yet',
      subtitle: 'Start chatting with your teammates!',
    },
    input: {
      placeholder: 'Type a message...',
    },
    time: {
      today: 'Today',
      yesterday: 'Yesterday',
    },
    errors: {
      sendFailed: 'Failed to send',
      networkError: 'Network error, please try again',
    },
    user: {
      unknown: 'Unknown user',
    },
  },

  // Expense Management
  expenseManagement: {
  fullAmount: 'Full amount',
    ledgerTabs: {
      public: 'Group ledger',
      private: 'Personal ledger',
    },
    // Statistics
    statistics: {
      title: 'Expense Statistics',
      settings: 'Settings',
      consumed: 'Consumed',
      totalExpense: 'Total Expense',
      approvedReceipts: 'Approved Receipts',
      pendingReview: 'Pending Review',
      averagePerPerson: 'Average Per Person',
      averagePerShare: 'Average Per Share',
      categoryStatistics: 'Expense Category Statistics',
      shareMode: 'Share Splitting',
      averageMode: 'Average Mode',
      perSharePayable: 'Per Share Payable',
      averageSplit: 'Average Split',
    },
    // Receipts
    receipts: {
      title: 'Receipts',
      upload: 'Upload',
      exportPDF: 'PDF',
      exporting: 'Exporting...',
      approve: 'Approve',
      reject: 'Reject',
    confirmDelete: 'Confirm delete',
    delete: 'Delete',
    deleteSuccess: 'Receipt deleted',
    deleteFailed: 'Delete failed',
      confirmTitle: 'Confirm Action',
      confirmApprove: 'Are you sure you want to approve this receipt?',
      confirmReject: 'Are you sure you want to reject this receipt?',
      cancel: 'Cancel',
      confirm: 'Confirm',
      approved: 'Receipt approved',
      rejected: 'Receipt rejected',
      success: 'Operation successful',
      error: 'Operation failed',
      approveFailed: 'Approval failed',
      rejectFailed: 'Rejection failed',
      operationFailed: 'Operation failed',
      imageUnavailable: 'Image unavailable',
      imageLoadError: 'Image load error',
      cannotDisplay: 'Cannot display image',
      emptyTitle: 'No receipts',
      emptySubtitle: 'Click upload button to start adding receipts',
    },
    privateReceipts: {
      modeInfo: 'These receipts are personal to each member and only affect their own split balance.',
      loading: 'Loading private receipts…',
      loadFailed: 'Failed to load private receipts',
      loadFailedHint: 'Check your connection and try again.',
      retry: 'Retry',
      emptyTitle: 'No private receipts yet',
      emptySubtitle: 'Members can upload their own personal receipts, or tap Upload above to add the first one.',
      settlementTitle: 'Private Settlements',
      settlementAmount: '{{payer}} owes {{receiver}} {{amount}}',
      settlementYouOwe: 'You owe {{receiver}} {{amount}}',
      settlementOwesYou: '{{payer}} owes you {{amount}}',
      settlementEmpty: 'All settled—no private balances outstanding.',
      noPersonalSettlements: 'You have no private settlements.',
      noPersonalReceipts: 'No private receipts involve you yet.',
      noPersonalReceiptsSubtitle: 'Private splits between other members stay hidden here.',
      youLabel: 'You',
      vsSeparator: ' vs ',
    },
    privateMode: {
      info: 'Personal ledger mode: receipts uploaded here are private to each member and affect only that member\'s split.',
    },
    // Status
    status: {
      pending: 'Pending',
      approved: 'Approved',
      rejected: 'Rejected',
    },
    // Rejection Reason
    rejectionReason: {
      title: 'Rejection Reason',
    },
    // Reject Input
    rejectInput: {
      title: 'Reject Receipt',
      label: 'Please enter rejection reason:',
      placeholder: 'Please provide detailed reason for rejecting this receipt...',
      cancel: 'Cancel',
      confirm: 'Confirm Reject',
    },
    // Member Balance
    memberBalance: {
      title: 'Member Balance',
      paid: 'Paid',
      shouldPay: 'Should Pay',
      overpaid: 'Overpaid',
      owes: 'Owes',
      share: 'Share',
    },
    // Payment Mode
    paymentMode: {
      prepaid: 'Prepaid Mode',
      actualExpense: 'Actual Expense',
      shareMode: 'Share Mode',
      equalMode: 'Equal Mode',
    },
    // Category Statistics
    categoryStats: {
      title: 'Category Statistics',
      total: 'Total',
    },
    // Categories
    categories: {
      transport: 'Transport',
      accommodation: 'Accommodation',
      food: 'Food & Dining',
      flight: 'Flight',
      taxi: 'Taxi',
      attractions: 'Attractions',
      shopping: 'Shopping',
      entertainment: 'Entertainment',
      insurance: 'Insurance',
      visa: 'Visa',
      communication: 'Communication',
      general: 'Other',
    },
    // Export
    export: {
      error: 'Export failed',
      noData: 'No data to export',
      success: 'Export successful',
      successMessage: 'PDF report generated and ready to share',
      failed: 'Export failed, please try again',
    },
    // PDF Report Translations
    pdfReport: {
      title: 'Expense Report',
      subtitle: 'Financial Details & Statistical Analysis',
      generatedBy: 'PDF Generated by',
      brandName: 'Cube Meet',
      brandWebsite: 'https://cubemeet.app',
      generatedAt: 'at',
      brandFooter: 'Powered by Cube Meet - Smart Financial Management Platform',
      brandSlogan: 'Smart Living, Starting with Expense Tracking',
      // Section Titles
      sections: {
        overview: 'Financial Overview',
        memberBalances: 'Member Balance Details',
        expenseDetails: 'Expense Details',
        receipts: 'Expense Receipt Details',
        categoryStats: 'Expense Category Statistics',
        categoryBreakdown: 'Category Breakdown',
      },
      // Overview Items
      overview: {
        totalExpense: 'Total Expense',
        memberCount: 'Members',
        approvedReceipts: 'Approved Receipts',
        pendingReceipts: 'Pending Receipts',
        memberUnit: ' members',
        receiptUnit: ' receipts',
      },
      // Table Headers
      tableHeaders: {
        member: 'Member',
        spent: 'Spent',
        shouldPay: 'Should Pay',
        balance: 'Balance',
        share: 'Share',
        title: 'Title',
        amount: 'Amount',
        category: 'Category',
        date: 'Date',
        uploader: 'Uploader',
        status: 'Status',
        percentage: 'Percentage',
        unknown: 'Unknown',
      },
      // Status Translations
      status: {
        approved: 'Approved',
        rejected: 'Rejected',
        pending: 'Pending',
        unknown: 'Unknown',
      },
      // Balance Status
      balanceStatus: {
        overpaid: 'Overpaid',
        owed: 'Owed',
      },
    },
  },

  // Card Detail Page
  cardDetail: {
    tabs: {
      book: 'Book',
      details: 'Details',
      nearby: 'Nearby',
      description: 'Description',
    },
    gallery: {
      allPhotos: 'All Photos',
      tripPhotos: 'Trip Photos',
      addPhoto: 'Add Photo',
    },
    affiliate: {
      bookOn: 'Book on {{brand}}',
      searchOn: 'Search on {{brand}}',
    },
  },

  // Travel Post Detail
  travelPostDetail: {
    loading: 'Loading...',
    emptyContent: 'No content yet',
    meta: {
      defaultTitle: 'Travel Note',
      siteName: 'Cubemeet',
    },
    breadcrumbs: {
      home: 'Home',
      city: 'City',
      guide: 'Guide',
    },
    messages: {
      cloneSuccess: 'Itinerary copied, redirecting...',
      cloneFailed: 'Failed to copy itinerary, please try again later',
      postNotFound: 'Post not found or has been deleted',
      loadFailed: 'Failed to load post',
      followFailed: 'Follow failed',
      followed: 'Followed',
      noMapData: 'No map data available',
    },
    actions: {
      retry: 'Retry',
      back: 'Back',
      backToTop: 'Back to Top',
      cloning: 'Creating itinerary...',
      cloneToItinerary: 'Copy to My Itinerary',
      viewMap: 'Map View',
    },
    error: {
      notFound: 'Post not found',
    },
    cloneModal: {
      title: 'Copy to My Itinerary',
      labelTitle: 'Itinerary Title',
      placeholderTitle: 'Enter itinerary title',
      labelStartDate: 'Start Date',
      cancel: 'Cancel',
      confirm: 'Confirm Copy',
      copyOf: 'Copy of',
    },
    postEngagement: {
      auth: {
        authenticated: 'User authenticated',
        unauthenticated: 'User unauthenticated',
        pleaseLogin: 'Please login to comment',
        checkFailed: 'Auth check failed',
      },
      comment: {
        anonymous: 'Anonymous',
        empty: 'Comment is empty',
        start: 'Posting comment...',
        success: 'Comment posted',
        reload: 'Reloading comments...',
        failed: 'Failed to post comment',
        unknownError: 'Unknown error',
        placeholder: 'Say something...',
        sending: 'Sending...',
        send: 'Send',
        total: '{{count}} comments',
        loading: 'Loading comments...',
        loadMore: 'Load more comments',
        avatarError: 'Failed to load avatar, using default',
      },
      time: {
        justNow: 'Just now',
        minsAgo: '{{count}}m ago',
        hoursAgo: '{{count}}h ago',
        daysAgo: '{{count}}d ago',
      },
      badge: {
        author: 'Author',
        admin: 'Admin',
        agency: 'Verified',
      },
      richContent: {
        imageLoadFailed: 'Image failed to load:',
        imageAlt: 'Image',
        empty: 'No content',
      },
    },
  },

  snapshot: {
      noContent: 'No content available',
      imageLoadFailed: 'Image failed to load',
      day: 'Day {{number}}',
      openCardDetails: 'Open card details',
      openCardInNewWindow: 'Open card in new window',
      prevImage: 'Previous image',
      nextImage: 'Next image',
    },
};